import { Grid2, Grid2Props } from '@mui/material';

//
//

export const AppGridContainer = ({
  children,
  container = true,
  spacing = 2,
  ...props
}: Grid2Props) => (
  <Grid2 container={container} spacing={spacing} {...props}>
    {children}
  </Grid2>
);

//

export const AppGridContent = ({ children, ...props }: Grid2Props) => {// Omit<Grid2Props, 'component'>
  return <Grid2 {...props}>{children}</Grid2>;
};
